import { createFileRoute } from '@tanstack/react-router'
import { AboutPage } from '../components/pages'
import { CatalogProvider } from '../content/catalog-context'
import { loadPageData } from '../content/page-data-fn'
import { staticRouteHead } from '../lib/seo'

export const Route = createFileRoute('/it/chi-siamo')({
  loader: () => loadPageData({ data: { kind: 'about', locale: 'it' } }),
  head: () => staticRouteHead('about', 'it'),
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <CatalogProvider snapshot={Route.useLoaderData().snapshot}>
      <AboutPage />
    </CatalogProvider>
  )
}
